import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { PostServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";
import moment from "moment";

const ViewTeamPRDetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [prEvaluationHeaderData, setPrEvaluationHeaderData] = useState({});
  const [prEvaluationTableData, setPrEvaluationTableData] = useState([]);
  const [dateHeader, setDateHeader] = useState({});

  useEffect(() => {
    if (id) {
      fetchPrEvaluationReport(id);
    }
  }, [id]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("View Performance Evaluation"))
  }, [])

  const [pageLoading, setPageLoading] = useState(false)
  const fetchPrEvaluationReport = async (id) => {
    setPageLoading(true)
    setLoading(true);

    try {
      const response = await PostServiceCaller(
        `${API_URL}fetch-performance-evaluation-details-team`,
        {
          performance_evaluation_id: id,
        },
        "post"
      );

      if (response?.status == 200) {
        const header = response?.data?.data?.empDeatails; // Corrected spelling from empDeatails
        const dateHeader = response?.data?.data?.performanceEvaluationHeader;
        const tableData = response?.data?.data?.performanceEvaluationLines;
        setDateHeader(dateHeader);
        setPrEvaluationHeaderData(header);
        setPrEvaluationTableData(tableData);
      }
    } catch (err) {
      console.error("Error fetching view Performance Evaluation report :", err);
    } finally {
      setLoading(false);
      setPageLoading(false);
    }
  };

  const renderResponse = (response, type = "Employee") => {
    const answer =
      type === "Employee" ? response?.EmployeeAnswer : response?.ReviewerAnswer;

    if (response?.QuestionType_202 === 1342) {
      // Textarea for long text answers
      return (
        <textarea
          disabled
          className="w-100"
          defaultValue={answer || "No answer provided"}
          rows={3}
        />
      );
    } else if (response?.QuestionType_202 === 1343) {
      // Radio buttons (single choice)
      const options = [
        response?.Option1,
        response?.Option2,
        response?.Option3,
        response?.Option4,
        response?.Option5,
      ].filter((opt) => opt !== null);

      return options.length > 0 ? (
        <div>
          {options.map((option, index) => (
            <div key={index} className="d-flex">
              <div>
                <input
                  type="radio"
                  name={`radio-${type}-${response?.LineNo}`}
                  disabled
                  style={{ marginRight: "10px" }}
                  defaultChecked={option === answer} // Check if the option matches the answer
                />
              </div>
              <div>{option}</div>
            </div>
          ))}
        </div>
      ) : (
        <div>No options provided</div>
      );
    } else if (response?.QuestionType_202 === 1347) {
      // Checkboxes (multiple choice)
      const options = [
        response?.Option1,
        response?.Option2,
        response?.Option3,
        response?.Option4,
        response?.Option5,
      ].filter((opt) => opt !== null);
      const selectedAnswers = answer?.split(",") || [];

      return options.length > 0 ? (
        <div>
          {options.map((option, index) => (
            <div key={index} className="d-flex">
              <div><input
                type="checkbox"
                name={`checkbox-${type}-${response?.LineNo}`}
                disabled
                defaultChecked={selectedAnswers.includes(option)}
              /></div>

              <div>{option}</div>
            </div>
          ))}
        </div>
      ) : (
        <div>No options provided</div>
      );
    }
    return null;
  };


const handlePrint = () => {
  const printContents = document.getElementById('printSection').innerHTML;
  const originalContents = document.body.innerHTML;

  document.body.innerHTML = printContents;
  window.print();
  document.body.innerHTML = originalContents;
};

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row mt-2 mr-3">
              <div className="text-end">
                <div className="justify-content-center">
                  <button className="custom-btn" onClick={handlePrint}>
                    <i className="bi bi-printer"></i> Print
                  </button>
                </div>
              </div>
            </div>
            <div id="printSection">
              <div className="row mt-1">
                <h4 className="text-bold">
                  {prEvaluationHeaderData?.EmployeeName}
                  <span class="fs-5">({prEvaluationHeaderData?.Designation})</span>
                </h4>
              </div>
              <div className="row mt-1 mr-3">
                <div className="row">
                  <div className="col-4">
                    <i className="bi bi-file-earmark"></i>
                    <span>
                      {" "}
                      Hire Date: {prEvaluationHeaderData?.JoiningDate ? moment(prEvaluationHeaderData?.JoiningDate).format("DD-MMM-YYYY") : null}
                    </span>
                  </div>
                  <div className="col-4">
                    <i className="bi bi-calendar-plus"></i>
                    <span> Evaluation Date: {dateHeader?.TXNDate ? moment(dateHeader?.TXNDate).format("DD-MMM-YYYY") : null}</span>
                  </div>
                  <div className="col-4">
                    <span>
                      {" "}
                      Appraisal Cycle:{" "}
                      {prEvaluationHeaderData?.AppraisalCycleName}
                    </span>
                  </div>
                </div>
                <div className="row mt-1">
                  <div className="col-4">
                    <i className="bi bi-calendar-plus"></i>
                    <span>
                      {" "}
                      Reviewer: {prEvaluationHeaderData?.ReviewerName}
                    </span>
                  </div>
                  <div className="col-4">
                    <i className="bi bi-calendar-plus"></i>
                    <span> Review Date: {dateHeader?.ReviewDate ? moment(dateHeader?.ReviewDate).format("DD-MMM-YYYY") : null}</span>
                  </div>
                </div>
              </div>
              <div className="row mx-2 mt-2">
                <Table bordered hover>
                  <thead id="thcolor" className="text-center">
                    <tr>
                      <th>#</th>
                      <th>Employee Response</th>
                      <th>Reviewer Response</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prEvaluationTableData.map((response, index) => (
                      <tr key={index}>
                        <td>{response.LineNo}</td>
                        <td>
                          <div>
                            {/* <strong>Question:</strong>{" "} */}
                            {response?.question_title}
                          </div>
                          <div>{renderResponse(response, "Employee")}</div>
                        </td>
                        <td>
                          <div>
                            {/* <strong>Question:</strong>{" "} */}
                            {response?.question_title}
                          </div>
                          <div>{renderResponse(response, "Reviewer")}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div></div>
          </div>
        </div>
      </>
    );
  };
}

export default ViewTeamPRDetails;
